import { SupportedLanguages } from './types'

export const SET_LANGUAGE = 'SET_LANGUAGE'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const setLanguage = (language: SupportedLanguages | string) => {
  return {
    type: SET_LANGUAGE,
    language,
  }
}
